import React from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';

const EmergencyContact = ({ employee, activeAccordion, activeKey }) => {
  const { emergencyContactName, parsedEmergencyContactPhone, emergencyContactRelation } = employee;

  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'emergency-contact' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle as={Col} eventKey="3" className="card-header-title" onClick={activeAccordion}>
          Contacto de Emergencia
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="3">
        <Card.Body className="personal-data">
          <Row className="mt-3">
            <Col md={4} className="col-md-4">
              <div className="d-flex flex-column mb-3">
                <span className="type">Nombre y Apellido:</span>
                <span className={`answer ${!emergencyContactName ? 'text-grey' : ''}`}>
                  {emergencyContactName || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={4} className="col-md-4">
              <div className="d-flex flex-column mb-3">
                <span className="type">Relación:</span>
                <span className={`answer ${!emergencyContactRelation ? 'text-grey' : ''}`}>
                  {emergencyContactRelation || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col md={4} className="col-md-4">
              <div className="d-flex flex-column mb-3">
                <span className="type">Teléfono:</span>
                <span className={`answer ${!parsedEmergencyContactPhone ? 'text-grey' : ''}`}>
                  {parsedEmergencyContactPhone || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default EmergencyContact;
